// holidaySlice.ts
import { createSlice } from '@reduxjs/toolkit';
import { HolidayState } from './holidayTypes';
import {
    createHoliday,
    updateHoliday,
    deleteHoliday,
    fetchHolidayById,
    fetchAllHolidays,
    fetchAllHolidaysByMonth,
    fetchNextUpcomingHoliday
} from './holidayAction';

const initialState: HolidayState = {
    holidays: [],
    holidaysByMonths: [],
    selectedHoliday: undefined,
    nextUpcomingHoliday: undefined,
    loading: false,
    error: undefined,
};

const holidaySlice = createSlice({
    name: 'holidays',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Create Holiday
            .addCase(createHoliday.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(createHoliday.fulfilled, (state, action) => {
                state.loading = false;
                state.holidays.push(action.payload);
            })
            .addCase(createHoliday.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Update Holiday
            .addCase(updateHoliday.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(updateHoliday.fulfilled, (state, action) => {
                state.loading = false;
                const index = state.holidays.findIndex(hol => hol.Id === action.payload.Id);
                if (index !== -1) {
                    state.holidays[index] = action.payload;
                }
            })
            .addCase(updateHoliday.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Delete Holiday
            .addCase(deleteHoliday.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(deleteHoliday.fulfilled, (state, action) => {
                state.loading = false;
                state.holidays = state.holidays.filter(hol => hol.Id !== action.meta.arg.holidayId);
            })
            .addCase(deleteHoliday.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Fetch Holiday by ID
            .addCase(fetchHolidayById.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchHolidayById.fulfilled, (state, action) => {
                state.loading = false;
                state.selectedHoliday = action.payload;
            })
            .addCase(fetchHolidayById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Fetch All Holidays
            .addCase(fetchAllHolidays.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchAllHolidays.fulfilled, (state, action) => {
                state.loading = false;
                state.holidays = action.payload.data;
            })
            .addCase(fetchAllHolidays.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            // Fetch Next Upcoming Holiday
            .addCase(fetchNextUpcomingHoliday.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchNextUpcomingHoliday.fulfilled, (state, action) => {
                state.loading = false;
                state.nextUpcomingHoliday = action.payload.data;
            })
            .addCase(fetchNextUpcomingHoliday.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            // Fetch All Holidays
            .addCase(fetchAllHolidaysByMonth.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchAllHolidaysByMonth.fulfilled, (state, action) => {
                state.loading = false;
                state.holidaysByMonths = action.payload.data;
            })
            .addCase(fetchAllHolidaysByMonth.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export default holidaySlice.reducer;
